var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "chat-message",
      class: { incoming: !_vm.value.userIsSender },
    },
    [
      _vm.value.senderImageUrl
        ? _c("div", {
            staticClass: "profile",
            style: { backgroundImage: `url(${_vm.value.senderImageUrl})` },
          })
        : _vm._e(),
      _c("div", { staticClass: "message" }, [
        _c("div", { staticClass: "info" }, [
          _vm.value.senderName
            ? _c("div", { staticClass: "sender-name" }, [
                _vm._v(" " + _vm._s(_vm.value.senderName) + " "),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "date-sent" },
            [_c("app-timeago", { attrs: { datetime: _vm.value.dateSent } })],
            1
          ),
        ]),
        _c("pre", {
          directives: [
            {
              name: "safe-html",
              rawName: "v-safe-html",
              value: _vm.content,
              expression: "content",
            },
          ],
          staticClass: "content",
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "images" },
          _vm._l(_vm.images, function (img, i) {
            return _c(
              "w-link",
              {
                key: i,
                staticClass: "image",
                on: {
                  click: function ($event) {
                    return _vm.onImageClick(img)
                  },
                },
              },
              [_c("img", { attrs: { src: img.fileUrl, alt: img.name } })]
            )
          }),
          1
        ),
        _c(
          "div",
          { staticClass: "files" },
          _vm._l(_vm.otherFiles, function (file, i) {
            return _c(
              "w-link",
              {
                key: i,
                on: {
                  click: function ($event) {
                    return _vm.onFileClick(file)
                  },
                },
              },
              [_vm._v(" " + _vm._s(file.fileName) + " ")]
            )
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }